// extracted by mini-css-extract-plugin
module.exports = {"wireless":"wireless-1Jxc-dPP","link":"link-MMKyrVPE","list":"list-3aWNBsRP clearfix"};